import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPeopleByDiscipline } from '../people/people.selectors';

import * as navigationActions from '../navigation/navigation.actions';
import * as peopleActions from '../people/people.actions';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
  PageLead,
} from '../content/components';

import { CrossLinksSection, TeamList } from './components';

class TeamPage extends Component {
  componentDidMount = () => {
    const { readPeople } = this.props;

    readPeople();
  };

  onModalClose = () => {
    const { navigate } = this.props;

    navigate(`/team`);
  };

  render() {
    const { peopleGrouped } = this.props;

    return (
      <ContentProvider
        slug="team"
        render={({ header, intro, cross_links }) => (
          <PageContainer>
            <PageHeader mainImage={header.main_image} />
            <PageLead
              title={header.title}
              subtitle={header.subtitle}
              content={intro.content}
              links={intro.links}
              supportImage={
                header.support_media_format === 'circular'
                  ? header.support_image_circular
                  : header.support_image_portrait
              }
              supportVideo={header.support_video}
              supportMediaType={header.support_media_type}
              supportIsCircular={header.support_media_format === 'circular'}
            />

            <TeamList people={peopleGrouped} />

            {cross_links && <CrossLinksSection crossLinks={cross_links} />}
          </PageContainer>
        )}
      />
    );
  }
}

TeamPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  readPeople: PropTypes.func.isRequired,
  peopleGrouped: PropTypes.array,
  sortParam: PropTypes.string,
};

const mapStateToProps = state => {
  const peopleGrouped = getPeopleByDiscipline(state);
  return {
    peopleGrouped,
  };
};

export default connect(
  mapStateToProps,
  Object.assign({}, peopleActions, navigationActions)
)(TeamPage);



// WEBPACK FOOTER //
// ./src/modules/pages/TeamPage.js